import { propertyQueryKeys as e } from "./usePropertiesQueryKeys.mjs";
import { runPropertyMediaUpload as t } from "./media/runPropertyMediaUpload.mjs";
import { useMutation as n, useQueryClient as r } from "@maat/store-hooks";
import { propertiesApi as i } from "@maat/api-main";
//#region src/properties/useUpdateListingImagesMutation.ts
var a = () => {
	let a = r();
	return n({
		mutationFn: ({ propertyId: e, unitId: n, listingId: r, deletes: a, keep: o, additions: s, onUploadProgress: c }) => t({
			propertyId: e,
			groups: s.map(({ category: e, space_index: t, files: n }) => ({
				category: e,
				space_index: t,
				files: n
			})),
			carriesEdits: !0,
			presign: (t) => i.presignPropertyImageEdits(e, {
				unit_id: n,
				listing_id: r,
				updates: {
					deletes: a,
					keep: o
				},
				media: t.length > 0 ? t : void 0
			}),
			onUploadProgress: c
		}),
		onSuccess: (t, { propertyId: n }) => {
			a.invalidateQueries({ queryKey: e.images(n) }), a.invalidateQueries({ queryKey: e.gallery(n) }), a.invalidateQueries({ queryKey: e.property(n) }), a.invalidateQueries({ queryKey: e.hostFeed() });
		}
	});
};
//#endregion
export { a as useUpdateListingImagesMutation };
